<template>
    <div id="apricationQQ">
        <div class="headerp-div">
            <div class="header-div">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="header-div" style="text-align: right">
                <div style="float: right">
                    <el-button size="mini" @click="handleSearch()"
                               style="background-color:#409EFF;color: white;">
                        查询<i class="el-icon-search"></i>
                    </el-button>
                </div>
                <div style="float: right">
                    <el-date-picker
                            @change="dateChang"
                            v-model="dateValues"
                            class="queryPzDate"
                            type="monthrange"
                            value-format="yyyy-MM"
                            align="right"
                            size="mini"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始月份"
                            end-placeholder="结束月份"
                            :picker-options="pickerOptions">
                    </el-date-picker>
                </div>
                <div style="float: right;margin-right: 5px;">
                    <el-select
                            @change="ftChange"
                            v-model="fzTy"
                            size="mini"
                            placeholder="辅助类别"
                            style="width: 123px;background-color: #ffffff;"
                    >
                        <el-option v-for="item in fzTyList" :label="item.fna" :value="item.fco"></el-option>
                    </el-select>
                </div>
            </div>
        </div>

        <div class="divTwo">
            <el-input
                    style="width: 100%;background-color: #f5fafe;height: 47px;"
                    placeholder="输入关键词进行筛选"
                    v-model="filterText">
            </el-input>
            <el-tree
                    style="height: 420px;overflow: auto;overflow-x: auto"
                    :indent="0"
                    class="filter-tree tree-line"
                    :data="xmKmList"
                    :props="defaultProps"
                    default-expand-all
                    :expand-on-click-node = "false"
                    :filter-node-method="filterNode"
                    @node-click="handleNodeClick"
                    ref="tree">
            </el-tree>
        </div>

        <div class="divOne">
            <div class="leftDivTop">
                <span v-if="xmTitleKmName!=''">[项目]：{{xmTitleKmName}}</span>
                <span style="margin-left: 20px;" v-if="kmTitleKmName!=''">[科目]：{{kmTitleKmName}}</span>
            </div>
            <el-table
                    :data="tableData"
                    border
                    height="398"
                    size="mini"
                    style="width: 100%;">
                <el-table-column
                        prop="pzDate"
                        label="日期"
                        width="180">
                </el-table-column>
                <el-table-column label="凭证字号" width="180">>
                    <template slot-scope="scope">
                        <a style="color: #409EFF;cursor: pointer"
                           @click="handleView(scope.row)">{{scope.row.pzhStr}}</a>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="zyJl"
                        label="摘要">
                    <template slot-scope="scope">
                        <span v-if="scope.row.pzhStr != null && scope.row.pzhStr != ''" style="color: #96a6ac;">{{scope.row.zyJl}}</span>
                        <span v-else style="color: rgba(0,0,0,0.8);">{{scope.row.zyJl}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="jfje"
                        label="借方(元)">
                </el-table-column>
                <el-table-column
                        prop="dfje"
                        label="贷方(元)">
                </el-table-column>
                <el-table-column
                        prop="yueFx"
                        label="方向">
                </el-table-column>
                <el-table-column
                        prop="yuE"
                        label="余额(元)">
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin-top: 25px;margin-right: 5px;"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    :page-sizes="[10, 50, 100, 500]"
                    :page-size="pageSize"
                    :current-page="currentPage"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
            ></el-pagination>
        </div>

        <pview v-if="pViewVisible" ref="pView"></pview>
    </div>
</template>
<script>
    import Pview from '../pingZheng/edit'

    export default {
        name: 'mxList2',
        components: {
            Pview
        },
        data() {
            return {
                pViewVisible: false,
                filterText: '',
                fzTy: '',
                xmKmList: [],
                fzTyList: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                currentPage: 1, //初始页
                pageSize: 10, //每页的数据
                total: 0,
                offset: 0,
                tableData: [],

                xmCode: '',
                kmCode: '',
                xmTitleKmName: '',
                kmTitleKmName: '',

                startTimeStr: null,
                endTimeStr: null,
                pickerOptions: {
                    shortcuts: [{
                        text: '本月',
                        onClick(picker) {
                            picker.$emit('pick', [new Date(), new Date()]);
                        }
                    }, {
                        text: '上月',
                        onClick(picker) {
                            let date = new Date();
                            // 2.获取今日的年月
                            let year = date.getFullYear();
                            let month = date.getMonth();
                            const end = new Date(year, month - 1, 1);
                            const start = new Date(year, month - 1, 1);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                dateValues: []
            }
        },
        methods: {
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            handleNodeClick(data, node, self) {

                this.xmCode = '';
                this.kmCode = '';
                this.xmTitleKmName = '';
                this.kmTitleKmName = '';

                if (data.xmKm) {
                    this.xmCode = data.fco;
                    this.xmTitleKmName = data.label;
                } else {
                    //获取父级项目节点
                    let pNode = node.parent.data;
                    this.xmCode = pNode.fco;
                    this.xmTitleKmName = pNode.label;

                    this.kmCode = data.fco;
                    this.kmTitleKmName = data.label;
                }
                this.handleCurrentChange(this.currentPage);
            },
            dateChang() {
                if (this.dateValues != null && this.dateValues.length > 0) {
                    this.startTimeStr = this.dateValues[0];
                    this.endTimeStr = this.dateValues[1];
                } else {
                    this.startTimeStr = null;
                    this.endTimeStr = null;
                }
            },
            searchTreeList() {
                //查询已经使用的项目科目列表
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/mingXiZhang/fzhsTreeList'),
                    method: 'post',
                    data: this.$httpTAG.adornData({fty: this.fzTy})
                }).then(res => {
                    if (res.data.code == 0) {
                        this.xmKmList = res.data.data;
                        if (this.xmKmList.length > 0) {
                            if (!this.xmCode && !this.kmCode) {
                                this.xmCode = this.xmKmList[0].fco;
                                this.xmTitleKmName = this.xmKmList[0].label;
                            }
                            this.handleCurrentChange(1);
                        }
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                })
            },
            handleCurrentChange(cPage) {
                this.tableData = [];
                this.offset = (cPage - 1) * this.pageSize;
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/mingXiZhang/fzhsList?td=' + new Date()),
                    method: 'get',
                    params: {
                        'offset': this.offset,
                        'limit': this.pageSize,
                        'xmCode': this.xmCode,
                        'kmCode': this.kmCode,
                        'startTimeStr': this.startTimeStr,
                        'endTimeStr': this.endTimeStr
                    }
                }).then(r => {
                    if (r.data.code == 0) {
                        this.tableData = r.data.data.pageUtils.rows;
                        this.total = r.data.data.pageUtils.total;
                        this.dateValues = r.data.data.dateValues;
                    } else {
                        this.$message({
                            type: 'error',
                            message: r.data.msg
                        })
                    }
                })
            },
            handleView(row) {
                let id = row.id;
                this.pViewVisible = true;
                this.$nextTick(() => {
                    this.$refs.pView.int(id, 1);
                })
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.handleCurrentChange(1);
            },
            handleSearch() {
                this.handleCurrentChange(1);
            },
            ftChange() {
                this.xmCode = '';
                this.kmCode = '';
                this.xmTitleKmName = '';
                this.kmTitleKmName = '';

                this.tableData = [];
                this.total = 0;

                this.searchTreeList();
            },
            getFzTyList() {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/fuZhuXm/allList'),
                    method: 'get'
                }).then(r => {
                    this.fzTyList = r.data.data;
                    if (this.fzTyList.length > 0) {
                        this.fzTy = this.fzTyList[0].fco
                        this.searchTreeList();
                    }
                })
            }
        },
        watch: {
            filterText: {
                handler(newVal, oldVal) {
                    this.$refs.tree.filter(newVal);
                }
            }
        },
        created: function () {
            this.getFzTyList();
        }
    }
</script>
<style scoped>
    .header-div {
        margin-bottom: 5px;
        float: left;
        width: 50%;
    }

    .queryInput >>> .el-input__inner {
        border-radius: 0px;
        width: 200px;
    }

    .divOne >>> .el-timeline-item__timestamp.is-bottom {
        margin-top: 2px !important;
    }

    .el-collapse-item div {
        padding-left: 20px;
        padding-bottom: 15px;
    }

    .divTwo >>> .el-collapse-item__arrow.el-icon-arrow-right {
        display: none;
    }

    .divOne {
        float: right;
        width: 74.66%;
        border: 1px solid #ddd;
        height: 530px;
        padding: 10px 0px;
    }

    .divTwo {
        float: left;
        width: 24.9%;
        border: 1px solid #ddd;
        height: 530px;
        padding: 10px 10px;
    }

    .leftDivTop {
        text-align: left;
        margin: 0px 10px 10px 10px;
        font-size: 15px;
        color: #333;
    }

    #apricationQQ >>> .el-table--border td, .el-table--border th {
        border-right: 1px solid #ddd !important;
    }

    #apricationQQ >>> .el-table--border th {
        border-right: 1px solid #ddd !important;
    }

    #apricationQQ >>> .el-table td, .el-table th.is-leaf {
        border-bottom: 1px solid #ddd !important;
    }

    #apricationQQ >>> .el-table th.is-leaf {
        border-bottom: 1px solid #ddd !important;
    }

    #apricationQQ >>> .el-table {
        border: 1px solid #ddd !important;
        border-right: 0px;
    }

    .queryPzDate {
        margin-right: 5px;
    }
</style>
<style lang="scss">
    .tree-line {
        .el-tree-node {
            position: relative;
            padding-left: 16px; // 缩进量
        }

        .el-tree-node__children {
            padding-left: 16px; // 缩进量
        }

        // 竖线
        .el-tree-node::before {
            content: "";
            height: 100%;
            width: 1px;
            position: absolute;
            left: -3px;
            top: -26px;
            border-width: 1px;
            border-left: 1px dashed #52627C;
        }

        // 当前层最后一个节点的竖线高度固定
        .el-tree-node:last-child::before {
            height: 38px; // 可以自己调节到合适数值
        }

        // 横线
        .el-tree-node::after {
            content: "";
            width: 24px;
            height: 20px;
            position: absolute;
            left: -3px;
            top: 12px;
            border-width: 1px;
            border-top: 1px dashed #52627C;
        }

        // 去掉最顶层的虚线，放最下面样式才不会被上面的覆盖了
        & > .el-tree-node::after {
            border-top: none;
        }

        & > .el-tree-node::before {
            border-left: none;
        }

        // 展开关闭的icon
        .el-tree-node__expand-icon {
            font-size: 16px;
            // 叶子节点（无子节点）
            &.is-leaf {
                color: transparent;
                // display: none; // 也可以去掉
            }
        }

    }

</style>